import { render, staticRenderFns } from "./ShiftSchedule.vue?vue&type=template&id=2633b6ae&lang=pug&"
import script from "./ShiftSchedule.vue?vue&type=script&lang=js&"
export * from "./ShiftSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports